/** @format */

import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Exit from 'img/exit.svg';
import { toggleVendorsForm } from 'state/slice/tabSlice';
import { useVendorForm } from '../hooks/useVendorForm';

/**
 * AddVendorsForm Component
 * Handles batch creation of global vendors
 */
export const AddVendorsForm: React.FC = () => {
  const dispatch = useDispatch();
  const { vendors, loading, error, success, addVendor, removeVendor, updateVendor, submitVendors, resetForm } =
    useVendorForm();

  const handleExit = useCallback(() => {
    resetForm();
    dispatch(toggleVendorsForm(false));
  }, [dispatch, resetForm]);

  // Show success/error toasts
  useEffect(() => {
    if (success) {
      toast.success('Vendors added successfully!');
      handleExit();
    }
  }, [success, handleExit]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const handleChange = (index: number, globalName: string) => {
    updateVendor(index, globalName);
  };

  const handleAddVendor = () => {
    addVendor();
  };

  const handleRemoveVendor = (index: number) => {
    removeVendor(index);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await submitVendors();
  };

  return (
    <div className='form-layout'>
      <div className='exit-form-wrapper' style={{ width: '880px' }}>
        <button
          className='exit-form'
          style={{ float: 'right', marginBottom: '30px' }}
          onClick={handleExit}
          type='button'>
          <img src={Exit} alt='Exit Button' style={{ cursor: 'pointer' }} />
        </button>
      </div>
      <form onSubmit={handleSubmit} className='vendors-form-conainer'>
        <h2>Add New Vendor</h2>
        <div className='vendors-form-wrapper'>
          {vendors.map((vendor, index) => (
            <div className='vendors-input-container' key={index}>
              <input
                type='text'
                placeholder='Vendor Name'
                value={vendor.globalName}
                onChange={(e) => handleChange(index, e.target.value)}
                disabled={loading}
                required
              />
              <button
                type='button'
                onClick={() => handleRemoveVendor(index)}
                disabled={loading}>
                Remove
              </button>
            </div>
          ))}
        </div>
        <div className='vendors-form-button-conainer'>
          <button type='button' onClick={handleAddVendor} disabled={loading}>
            Add Vendor
          </button>
          <button type='submit' disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
};
